import styled from 'styled-components';
import { theme } from '../../../styles/constants';

export const StyledBasicButton = styled.button`
  position: relative;
  width: 100%;
  height: 4.6rem;
  padding: ${props => (props.$isLoading ? '0' : '1.2rem')};
  border-radius: 16px;
  color: ${theme.colors.white};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.42px;
  border: 1px solid transparent;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  cursor: pointer;

  &:disabled {
    border: 1px solid transparent;
    cursor: not-allowed;
    background: #f5f5f5;
    font-weight: 500;
    color: #000;
  }
`;

export const StyledButton = styled(StyledBasicButton)`
  border: 1px solid #61ade9;
  background: linear-gradient(180deg, #1a88df 0%, #1672ba 100%);
`;

export const StyledTransparentButton = styled(StyledBasicButton)`
  background-color: transparent;
  color: ${theme.colors.textColor};
`;

export const ButtonIconWrapper = styled.div`
  height: 4.4rem;
  display: flex;
  align-items: center;
`;

export const ButtonLoader = styled.img`
  height: 90%;
  aspect-ratio: 1 / 1;
`;
